module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/bg-bottom-122ef95edd6c8d4c375be41a0e068391.png";